import { Skeleton } from "@design-system/DataDisplay/Skeleton";
import { FlexCol, FlexRow } from "@design-system/Layout/Flex";
import { type FC } from "react";

const Chip = () => {
    return <Skeleton className="rounded-full h-[34px] w-[120px]" />;
};

const Input = () => {
    return <Skeleton className="rounded-lg h-[54px] w-full rounded-lg" />;
};

const Title = () => {
    return <Skeleton className="h-[32px] w-[200px]" />;
};

const Label = () => {
    return <Skeleton className="h-[20px] w-[300px]" />;
};

const Button = () => {
    return <Skeleton className="rounded-lg h-full w-full" />;
};

const Header = () => {
    return (
        <FlexRow
            className="border-b border-tertiary min-h-[67px] pl-4 pr-[56px]"
            w="full"
            alignItems="center"
            justifyContent="between"
        >
            <FlexRow gap="2" alignItems="center">
                <Skeleton className="rounded-full" h="6" w="6" br="full" />
                <Skeleton className="w-[60px]" h="4" />
            </FlexRow>
            <Chip />
        </FlexRow>
    );
};

const Body = () => {
    return (
        <FlexCol h="full" px="4" py="6" gap="6">
            <Title />
            <FlexCol gap="2">
                <Label />
                <Input />
            </FlexCol>
            <FlexCol gap="2">
                <Label />
                <FlexRow gap="2">
                    <Chip />
                    <Chip />
                    <Chip />
                </FlexRow>
            </FlexCol>
            <Label />
            <Input />
            <FlexRow className="max-w-[292px]" gap="4">
                <Input />
                <Input />
            </FlexRow>
        </FlexCol>
    );
};

const Footer = () => {
    return (
        <FlexRow className="border-t border-tertiary h-[65px] pl-4 gap-4 p-4">
            <Button />
            <Button />
        </FlexRow>
    );
};

export const ObjectiveSkeleton: FC = () => {
    return (
        <>
            <Header />
            <Body />
            <Footer />
        </>
    );
};
